module.exports = __webpack_public_path__ + "media/images/pc/stores/common/icon_line-5bbe70bc2d44955ed85cf4922562a9e8.png";